import PiiRemovalRequest, { PiiRemovalRequestButtonProps } from '~/pages/customer/reports/report-details/PiiRemovalRequest';

function PiiRemovalRequestButton({ refetchData }: PiiRemovalRequestButtonProps) {
  return <PiiRemovalRequest refetchData={refetchData}/>;
}

export default PiiRemovalRequestButton;
